// src/components/charting/DentalArch.tsx
import React from "react";
import "../../css/DentalArch.css";
import ToothDiagram from "./ToothDiagram";
import { ChartingState } from "../../pages/DentalChartingScreen";

// Import your specific images
import maxillaryArchImage from "../../assets/maxillary-arch.png";
import mandibularArchImage from "../../assets/mandibular-arch.png";

// interface DentalArchProps {
//   onToothSelect: (toothId: number) => void;
//   selectedTooth: number | null;
//   chartingData: ChartingState;
// }


interface DentalArchProps {
  onToothSelect: (toothId: number) => void;
  selectedTooth: number | null;
  chartingData: ChartingState;
  savedTeeth: Set<number>;
  viewedTabs: Set<string>;
}

// FINAL fine-tuned coordinates for Maxillary Arch (Upper Teeth - "n" shape)
const maxillaryTeeth: { id: number; top: string; left: string }[] = [
  { id: 55, top: "67%", left: "10%" },
  { id: 54, top: "46%", left: "15%" },
  { id: 53, top: "30%", left: "20%" },
  { id: 52, top: "18%", left: "33%" },
  { id: 51, top: "10%", left: "47%" },

  { id: 61, top: "10%", left: "59%" },
  { id: 62, top: "18%", left: "72%" },
  { id: 63, top: "30%", left: "85%" },
  { id: 64, top: "45%", left: "92%" },
  { id: 65, top: "65%", left: "95%" },
];

// FINAL fine-tuned coordinates for Mandibular Arch (Lower Teeth - "u" shape)
const mandibularTeeth: { id: number; top: string; left: string }[] = [
  { id: 85, top: "35%", left: "15%" },
  { id: 84, top: "53%", left: "20%" },
  { id: 83, top: "67%", left: "28%" },
  { id: 82, top: "75%", left: "38%" },
  { id: 81, top: "78%", left: "48%" },

  { id: 71, top: "78%", left: "57%" },
  { id: 72, top: "75%", left: "67%" },
  { id: 73, top: "67%", left: "78%" },
  { id: 74, top: "53%", left: "85%" },
  { id: 75, top: "35%", left: "90%" },
];

// const DentalArch: React.FC<DentalArchProps> = ({
//   onToothSelect,
//   selectedTooth,
//   chartingData,
// }) => {

const DentalArch: React.FC<DentalArchProps> = ({
  onToothSelect,
  selectedTooth,
  chartingData,
  savedTeeth,
  viewedTabs,
}) => {
  const renderToothButtons = (
    teeth: { id: number; top: string; left: string }[],
  ) => {
    return teeth.map((tooth) => {
      // const isSelected = selectedTooth === tooth.id;
      // const isUpdated = !!chartingData[tooth.id];
      // const buttonClass = `tooth-button ${isSelected ? "selected" : ""} ${isUpdated && !isSelected ? "updated" : ""}`;
const isSelected = selectedTooth === tooth.id;
const isSaved = savedTeeth.has(tooth.id);

let stateClass = "";

if (isSaved) {
  stateClass = "saved"; // 🟢
} else if (isSelected) {
  stateClass = "viewed"; // 🔵 (current active tooth)
}

const buttonClass = `tooth-button ${stateClass}`;

      return (
        <button
          key={tooth.id}
          className={buttonClass}
          style={{ top: tooth.top, left: tooth.left }}
          onClick={() => onToothSelect(tooth.id)}
        >
          {tooth.id}
        </button>
      );
    });
  };


  return (
    <div className="dental-arch-container">
      {/* LEFT SIDE (Heading + Images) */}
      <div className="arch-left">
        <h3 className="arch-title">Maxillary Arch and Mandibular Arch</h3>

        {/* Maxillary */}
        <div className="arch-image-wrapper">
          <img
            src={maxillaryArchImage}
            alt="Maxillary Arch"
            className="arch-background-image"
          />
          {renderToothButtons(maxillaryTeeth)}
        </div>

        {/* Mandibular */}
        <div className="arch-image-wrapper">
          <img
            src={mandibularArchImage}
            alt="Mandibular Arch"
            className="arch-background-image"
          />
          {renderToothButtons(mandibularTeeth)}
        </div>
      </div>

    </div>
  );
};
export default DentalArch;
